import FavoriteIcon from '@mui/icons-material/Favorite';
import CoffeeIcon from '@mui/icons-material/Coffee';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import type { ElementType } from 'react';

export const HOMEABOUT_ICONS: Record<string, ElementType> = {
    'bullet-1': FavoriteIcon,
    'bullet-2': CoffeeIcon,
    'bullet-3': WhatshotIcon,
};